module.exports = "<igo-ogc-filterable-list igoOgcFilterableListBinding></igo-ogc-filterable-list>\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/tool/tools/ogc-filter-tool/ogc-filter-tool.component.html
// module id = 1169
// module chunks = 0